import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import styles from './Start.scss';

export default class Start extends Component {
  componentDidMount() {
    this.container = document.querySelector('body');
    this.container.classList.add('start-engine');
  }

  componentWillUnmount() {
    this.container.classList.remove('start-engine');
  }

  render() {
    return (
      <div className={styles.Start}>
        <Link
          to="home"
          className={styles['intro-button']}
        >
          Start the engine
        </Link>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Start/Start.js